import {
  ActionButton,
  BaseTable,
  Button,
  Loading,
  TableHeader,
  TableNumber
} from "components"
import moment from "moment"
import { TaskList } from "pages/Task/types"
import { useTaskList } from "pages/Task/utils/hooks"
import { TASK_PRIORITY, TASK_STATUS } from "pages/Task/utils/vars"
import { useState } from "react"
import { IoSendSharp } from "react-icons/io5"
import { useToggle } from "utils"
import { ModalDelete } from "../../ModalDelete"

type TableTaskListProps = {
  tasks: ReturnType<typeof useTaskList>
  onOpenTask: (task: TaskList) => void
}

export const TableTaskList = ({ tasks, onOpenTask }: TableTaskListProps) => {
  const modalDelete = useToggle(false)
  const [deleteData, setDeleteData] = useState<TaskList>({} as TaskList)

  return (
    <div className="overflow-x-auto max-h-[52vh]">
      <BaseTable>
        <TableHeader sticky={true} className="uppercase z-1">
          <tr>
            <th>NO</th>
            <th colSpan={2}>Task Id</th>
            <th>Departement</th>
            <th>Date</th>
            <th>%</th>
            <th>Subject</th>
            <th>Priority</th>
            <th>Status</th>
            <th>Owner Task</th>
            <th rowSpan={2}>Action</th>
          </tr>
        </TableHeader>

        <tbody>
          {tasks.data?.length && !tasks.isLoading ? (
            tasks.data.map((item, key) => {
              return (
                <tr key={key}>
                  <td>
                    {TableNumber({
                      index: key,
                      dataLength: tasks.paging?.limit ?? 5,
                      pageCurrent: tasks.paging?.page ?? 1,
                      limit: tasks.paging?.size ?? 1,
                      totalData: tasks.paging?.total ?? 0
                    })}
                  </td>
                  <td className="text-center px-0">
                    <Button
                      size="xs"
                      color="ghost"
                      onClick={() => onOpenTask(item)}
                      title="Open task detail"
                    >
                      <IoSendSharp className="size-4" />
                    </Button>
                  </td>
                  <td> {item.trx_code} </td>
                  <td>{item.department_name}</td>
                  <td>{moment(item.date_end).format("DD/MM/YYYY")}</td>
                  <td className="text-right">
                    {parseFloat(item.progress?.toString() ?? "0").toFixed(2)}
                  </td>
                  <td>{item.subject}</td>
                  <td className="text-center">
                    {TASK_PRIORITY[item.priority]}{" "}
                  </td>
                  <td className="text-center">
                    {TASK_STATUS[item.task_status]}{" "}
                  </td>
                  <td>{item.owner_name}</td>
                  <td>
                    <div className="flex justify-center items-center">
                      {item.candel === 1 ? (
                        <ActionButton.Delete
                          onClick={() => {
                            modalDelete.setActive(true)
                            setDeleteData(item)
                          }}
                        />
                      ) : null}
                    </div>
                  </td>
                </tr>
              )
            })
          ) : (
            <tr>
              <td colSpan={12} className="text-center">
                <Loading
                  loading={tasks.isLoading}
                  errorText={tasks.isLoading ? "" : "No data available"}
                />
              </td>
            </tr>
          )}
        </tbody>
      </BaseTable>

      <ModalDelete
        data={deleteData}
        modalState={modalDelete}
        onSuccess={() => tasks.refetch()}
      />
    </div>
  )
}
